import { useEffect, useMemo } from 'react';
import { NumberGenerationType } from '@/Enums';
import { useDispatch, useSelector } from 'react-redux';
import { emailSendModalSelectors } from '@/ModalWindows/EmailSendModal/services/selectors';
import { documentPrintModalSelectors } from '@/ModalWindows/DocumentPrintModal/services/selectors';
import { emailSendModalAsyncActions } from '@/ModalWindows/EmailSendModal/services/reducer';
import { documentPrintModalAsyncActions } from '@/ModalWindows/DocumentPrintModal/services/reducer';
import { WINDOW_MODAL_TYPE } from '@/ModalWindows/services';

export function useGenerateDocumentNumbersOptions(numberGenerationType?: NumberGenerationType) {
  const dispatch = useDispatch();

  const documentPrintType = WINDOW_MODAL_TYPE[location.pathname];
  const documentTemplates = useSelector(documentPrintModalSelectors.documentTemplates);
  const emailTemplates = useSelector(emailSendModalSelectors.rows);

  useEffect(() => {
    dispatch(emailSendModalAsyncActions.getEmailTemplates(documentPrintType));
    dispatch(documentPrintModalAsyncActions.getDocumentTemplates(documentPrintType));
  }, []);

  return useMemo(() => {
    const resultDocumentTemplate = documentTemplates.find((item) => {
      return item.numberGenerationType == numberGenerationType;
    });

    const resultEmailTemplate = emailTemplates.find((item) => {
      return item.numberGenerationType == numberGenerationType;
    });

    return {
      selectedPrintTemplate: resultDocumentTemplate,
      selectedEmailTemplate: resultEmailTemplate,
    };
  }, [numberGenerationType, documentTemplates, emailTemplates]);
}
